<mat-label [ngStyle]="style">{{ text }}</mat-label>
